module.exports = __webpack_public_path__ + "static/media/my-profile-white.fc23197f.svg";